import { render, staticRenderFns } from "./BaseUploadCard.vue?vue&type=template&id=3a079622&scoped=true&"
import script from "./BaseUploadCard.vue?vue&type=script&lang=js&"
export * from "./BaseUploadCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseUploadCard.vue?vue&type=style&index=0&id=3a079622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a079622",
  null
  
)

export default component.exports